import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const YouTubeWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 39 35"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <g clipPath="url(#b)">
          <path
            fill="#fff"
            d="M18 9.37s6.782 0 8.477.467a2.72 2.72 0 0 1 1.91 1.92c.465 1.706.447 5.26.447 5.26 0 .038-.003 3.546-.446 5.242a2.724 2.724 0 0 1-1.91 1.92c-1.696.45-8.478.45-8.478.45-.05 0-6.77-.002-8.478-.467a2.723 2.723 0 0 1-1.909-1.92c-.446-1.688-.446-5.243-.446-5.243 0-.037.003-3.545.446-5.241.25-.933 1-1.687 1.91-1.939C11.211 9.372 17.95 9.37 18 9.37Zm-2.158 10.897 5.64-3.268-5.64-3.267v6.535Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="b">
          <path fill="#fff" d="M7.167 8.333h21.667v17.333H7.167z" />
        </clipPath>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-4"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_113047" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_113047" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
